import React, { useRef, useEffect, useState } from "react";
import styles from "./SettingsMain.module.css";
import cont from "../../../assets/images/cont.png";
import edit from "../../../assets/images/edit.svg";
import horn from "../../../assets/images/horn.svg";

import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";

import { uploadProfileImageApi } from "../../../config/uploadProfileImageApi";
import { updateUserProfileApi } from "../../../config/updateUserProfile";
import { getUserApi } from "../../../config/getUserApi";

import { Link,useHistory } from "react-router-dom";

export default function SettingsMain() {
  const history = useHistory()
  const imageInput = useRef(null);
  const save = useRef(null);
  const selectCont = useRef(null)
  const [token, setToken] = useState("");
  const [file, setFile] = useState(cont);
  const [id, setId] = useState("");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [country, setCountry] = useState(undefined);
  const [state, setState] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);

  const [name,setName] = useState("")
  const[city,setCity] = useState("")

  useEffect(()=>{
    if(country === ""){
      setCountry(undefined)
    }
  },[country])

  useEffect(()=>{
    if(state === ""){
      setState(undefined)
    }
  },[state])

  useEffect(() => {
    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }
      const item = JSON.parse(itemStr);
      setToken(item.value.token);
      setId(item.value.user_data._id);
      setName(`${item.value.user_data.first_name} ${item.value.user_data.last_name}`)
      setCity(item.value.user_data.state)
      setFirstName(item.value.user_data.first_name);
      setLastName(item.value.user_data.last_name);
      setPhone(item.value.user_data.phone_number);
      setEmail(item.value.user_data.email);
      setFile(item.value.user_data.profile_img)
      if(((item.value.user_data.country) !== undefined) && ((item.value.user_data.country) !== null)){
      setCountry(item.value.user_data.country)
    }
    if(((item.value.user_data.state) !== undefined ) && ((item.value.user_data.state) !== null)){
      setState(item.value.user_data.state)
    }
    
    }
    getWithExpiry("userData");
  }, []);

  const selectImage = () => {
    imageInput.current.click();
  };
  const handleImage = (e) => {
    console.log(e.target.files[0])
    setLoading1(true)
    const image = e.target.files[0];

    const upload = async () => {
      const uploadImage = await uploadProfileImageApi(image, token);

      if (uploadImage.error) {
        setLoading1(false)
        toast.error(
          <span style={{ display: "flex", alignItems: "center" }}>
            <BiError size="30" style={{ marginRight: "10px" }} />
            {uploadImage.error.message}
          </span>,
          {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
      } else if (uploadImage.data) {
        setFile(uploadImage.data.profile_img);
        setTimeout(() => {
          setLoading1(false)
        }, 500);

      }
    };
    upload();
  };

  const saveData = () => {
    setLoading(true)
    save.current.setAttribute("disabled", "disabled");
    
    const upload = async () => {
      const updateProfile = await updateUserProfileApi(id, token, {
        first_name: firstName,
        last_name: lastName,
        profile_img: file,
        phone_number: phone,
        country: country,
        state: state
      });
      if (updateProfile.error) {
        setLoading(false)
        save.current.removeAttribute("disabled");

        if(updateProfile.error.message === "Request failed with status code 422"){
          toast.error(
            <span style={{ display: "flex", alignItems: "center" }}>
              <BiError size="30" style={{ marginRight: "10px" }} />
              All Fields Required
            </span>,
            {
              position: "bottom-left",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            }
          );
        }
        else{
        toast.error(
          <span style={{ display: "flex", alignItems: "center" }}>
            <BiError size="30" style={{ marginRight: "10px" }} />
            {updateProfile.error.message}
          </span>,
          {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
        }
      }
      else if (updateProfile.data) {
        setLoading(false)
        toast.success(
          <span style={{ display: "flex", alignItems: "center" }}>
            <BsCheckAll size="30" style={{marginRight: "10px"}} />
            Profile Updated
          </span>,
          {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
        save.current.removeAttribute("disabled");

        const userData = JSON.parse(localStorage.userData);
        userData.value.user_data = updateProfile.data.data
        localStorage.setItem("userData", JSON.stringify(userData));
        setCity(state)
        setName(`${firstName} ${lastName}`)
        setTimeout(() => {
        history.push('/dashboard/home/')
        }, 1000);
      }

    }
    upload()
  };

  return (
    <div className={styles.main}>
      <h1 className={styles.Heading}>Settings</h1>
      <div className={styles.MainCont}>
        <div className={styles.firstCont}>
          <div className={styles.firstIn}>
            <div>
              <img src={file} alt="Image" className={styles.image} />
              <span className={styles.edit} onClick={() => selectImage()}>
                {loading1 ?
                (
                  <div
                className="spinner-border"
                role="status"
                style={{ height: "10px", width: "10px", color: "#ffffff" }}
              ></div>
                ) 
                :
                (
                <img src={edit} alt="Alt" />
                ) 
              }
                <input
                  type="file"
                  accept="image/x-png,image/gif,image/jpeg"
                  name="image"
                  ref={imageInput}
                  onChange={(e) => handleImage(e)}
                  style={{ display: "none" }}
                />
              </span>
            </div>
            <div className={styles.marg}>
              <h2 className={styles.firstInHead}>{name}</h2>
              <p className={styles.firstInPera}>{city}</p>
            </div>
          </div>
          <div className={styles.firstCorner}>
            <div className={styles.hornCont}>
              <img src={horn} alt="Horn" className={styles.horn} />
              <div>
                <h4 className={styles.hornHead}>Need help?</h4>
                <p className={styles.hornPera}>We are a click away</p>
              </div>
            </div>
            <div>
              <button className={styles.cornerButton}>CHAT NOW</button>
            </div>
          </div>
        </div>
        <hr className={styles.line} />
        <h3 className={styles.head2}>PERSONAL INFORMATION</h3>
        <div className={styles.inputsCont}>
          <div>
            <label className={styles.label}>First Name</label>
            <br />
            <input
              type="text"
              className={styles.input}
              value={firstName}
              onChange={(e) => {
                setFirstName(e.target.value);
              }}
            />
          </div>
          <div>
            <label className={styles.label}>Last Name</label>
            <br />
            <input
              type="text"
              className={styles.input}
              value={lastName}
              onChange={(e) => {
                setLastName(e.target.value);
              }}
            />
          </div>
          <div>
            <label className={styles.label}>Phone</label>
            <br />
            <input
              type="text"
              className={styles.input}
              value={phone}
              onChange={(e) => {
                setPhone(e.target.value);
              }}
            />
          </div>
          <div>
            <label className={styles.label}>Email</label>
            <br />
            <input
              type="text"
              disabled
              className={styles.input}
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </div>
          <div>
            <label className={styles.label}>Country</label>
            <br />
            <input
              type="text"
              className={styles.input}
              value={country}
              onChange={(e) => {
                setCountry(e.target.value);
              }}
            />
          </div>
          <div>
            <label className={styles.label}>State</label>
            <br />
            <input
              type="text"
              className={styles.input}
              value={state}
              onChange={(e) => {
                setState(e.target.value);
              }}
            />
          </div>
        </div>
        <hr className={styles.line} />
        <div className={styles.bottomBtns}>
          <Link to="/dashboard/home">
            <button className={styles.btn1}>CANCEL</button>
          </Link>

          <button className={styles.btn2} ref={save} onClick={() => saveData()}>
            {loading ? (
              <div
                className="spinner-border"
                role="status"
                style={{ height: "30px", width: "30px" }}
              ></div>
            ) : (
              "Save"
            )}
          </button>
        </div>
      </div>
      <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        className={styles.toasst}
      />
    </div>
  );
}
